/* eslint-disable react/no-danger */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Layout = styled.div`
  width: 100%; 
  max-width: 685px;
  margin: 70px auto 0;
  background: #f6f6f6;
  padding: 20px 0 40px;
  .socials{
      display: flex;
      width: 200px;
      margin: 0 auto 20px;
      justify-content: space-between;
      align-items: center;
      img{
          margin: 0;
      }
  }
  .sitemap{
      display: flex;
      width: 300px;
      max-width: 100%;
      margin: 0 auto;
      justify-content: space-between;
      align-items: center;
      &.es{
        width: 370px;
      }
      &.pt{
        width: 325px;
      }
      a{
          font-size: 10px;
          color: #9b9b9b;
          text-decoration: none;
          border-right: 1px solid #9b9b9b;
          padding-right: 10px;
          transition: color ease 0.2s;
          @media all and (max-width: 500px){
            border: none;
          }
          &:hover{
            color: #000;
          }
          &:last-of-type{
              border: none;
              padding: 0;
          }
          p{
              margin: 0;
          }
      }
  }
  .separator{
      width: 200px;
      margin: 30px auto 38px;
      background: #d7d7d7;
      height: 1px;
  }
  .ploicy{
      display: flex;
      width: 300px;
      margin: 0 auto 10px;
      justify-content: center;
      align-items: center;
      a{
          font-size: 10px;
          color: #9b9b9b;
          text-decoration: underline;
          cursor: pointer;
          transition: color ease 0.2s;
          &:hover{
            color: #000;
          }
          p{
              margin: 0;
          }
       }
  }
  .legal{
      display: flex;
      width: 100%;
      margin: 0 auto;
      justify-content: center;
      align-items: center;
      p{
          margin: 0;
          font-size: 10px;
          color: #9b9b9b;
      }
  }
`;

const Footer = ({ imgPrefix, copy, lang }) => (
  <Layout>
    <div className="socials">
      <a href="https://www.facebook.com/hertz" target="_blank" rel="noopener noreferrer">
        <img src={`${imgPrefix}/images/fb_icon.png`} alt="" />
      </a>
      <a href="https://twitter.com/Hertz" target="_blank" rel="noopener noreferrer">
        <img src={`${imgPrefix}/images/tw_icon.png`} alt="" />
      </a>
      <a href="https://www.instagram.com/hertz/" target="_blank" rel="noopener noreferrer">
        <img src={`${imgPrefix}/images/ig_icon.png`} alt="" />
      </a>
      <a href="https://www.youtube.com/user/hertzcarrental" target="_blank" rel="noopener noreferrer">
        <img src={`${imgPrefix}/images/yt_icon.png`} alt="" />
      </a>
    </div>
    <div className={`sitemap ${lang}`}>
      <a href="https://www.hertz.com/rentacar/reservation/" target="_blank" rel="noopener noreferrer">
        <p dangerouslySetInnerHTML={{ __html: copy.sitemap.reservations }} />
      </a>
      <a href="https://www.hertz.com/rentacar/customersupport/index.jsp?targetPage=contactUsTypeSelectionView.jsp" target="_blank" rel="noopener noreferrer">
        <p dangerouslySetInnerHTML={{ __html: copy.sitemap.contact }} />
      </a>
      <a
        href="https://www.hertz.com/rentacar/privacypolicy/index.jsp?targetPage=privacyPolicyView.jsp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <p dangerouslySetInnerHTML={{ __html: copy.sitemap.privacy }} />
      </a>
      <a href="https://www.hertz.com/rentacar/rental-car-deals" target="_blank" rel="noopener noreferrer">
        <p dangerouslySetInnerHTML={{ __html: copy.sitemap.offers }} />
      </a>
    </div>
    <div className="separator" />
    <div className="legal">
      <p dangerouslySetInnerHTML={{ __html: copy.legal.copy }} />
    </div>
  </Layout>
);

Footer.defaultProps = {
};

Footer.propTypes = {
  lang: PropTypes.string.isRequired,
  imgPrefix: PropTypes.string.isRequired,
  copy: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default Footer;
